module.exports = __webpack_public_path__ + "static/media/failure.16736ae1.svg";